"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.accumulationAssemble = void 0;
exports.accumulationAssemble = function (axios) {
    return {
        // [Accumulation-Assemble]
        getAccumulationsAssembles: function (request) {
            return axios.get('/accumulations/assembles', request);
        },
        postAccumulationsAssembles: function (request) {
            return axios.post('/accumulations/assembles', request.data);
        },
        getAccumulationsAssemblesRequestNo: function (request) {
            return axios.get("/accumulations/assembles/" + request.pathParams.requestNo, request);
        },
        putAccumulationsAssemblesRequestNo: function (request) {
            return axios.put("/accumulations/assembles/" + request.pathParams.requestNo, request.data, request);
        },
        deleteAccumulationsAssemblesRequestNo: function (request) {
            return axios.delete("/accumulations/assembles/" + request.pathParams.requestNo, request);
        },
        getAccumulationsAssemblesRequestNoMembers: function (request) {
            return axios.get("/accumulations/assembles/" + request.pathParams.requestNo, request);
        },
        getAccumulationsAssemblesRequestNoResults: function (request) {
            return axios.get("/accumulations/assembles/" + request.pathParams.requestNo + "/results", request);
        }
    };
};
